<div class="idp__alertbanner idp__alertbanner--wrapper">
  <div
    class="banner-row banner-row-container idp__alertbanner--container"
    [ngClass]="bannerRowClass"
    [ngStyle]="styles.banner!"
  >
    <ng-container *ngIf="desktopBannerEnabled">
      <div
        class="idp__alertbanner--imageplaceholder idp__alertbanner--desktop banner-d-sm-none banner-d-md-block banner-col-1 text-align-center"
      >
        <idp-image
          class="idp__alertbanner--image-desktop"
          [content]="content.imageContent?.desktop!"
        ></idp-image>
      </div>
    </ng-container>

    <ng-container *ngIf="mobileBannerEnabled">
      <div
        class="idp__alertbanner--imageplaceholder idp__alertbanner--mobile banner-d-none banner-d-sm-block banner-d-md-none banner-col-1"
      >
        <idp-image [content]="content.imageContent?.mobile!"></idp-image>
      </div>
    </ng-container>

    <div class="idp__alertbanner--content banner-col-11">
      <div class="banner-row margin-0">
        <div class="banner-col-12 padding-0 margin-auto">
          <idp-heading
            *ngIf="!!content.headerText"
            [styles]="headerStyles"
            [content]="headerContent!"
            class="idp__alertbanner--heading"
          ></idp-heading>
          <ng-container *ngIf="!!content.badgeText">
            <idp-text
              class="idp__alertbanner--badge"
              [styles]="styles.badge!"
              [content]="content.badgeText"
            ></idp-text>
          </ng-container>
        </div>
        <ng-container *ngIf="!!content.description">
          <div class="banner-col-12 padding-0 idp__alertbanner--description">
            <idp-text
              class="idp__alertbanner--subheading"
              [styles]="styles.description!"
              [content]="content.description"
            ></idp-text>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>
